import auth from './tools/storage.js';
import permissions from './tools/permissions.js';
import mainWindow from './login/main_login_window.js';
// import mainViewContent from './fest/main_view_fest_content.js';

// import searchViewFestContent from './fest/search_view_fest_content.js';
import universalListOfData from './lk/universalListOfData.js';

// import lkRegionsBody from './lk/regions-body.js';
// import lkCitiesBody from './lk/cities-body.js';
// import lkContriesBody from './lk/countries-body.js';
// import lkTechnologiesBody from './lk/technologies-body.js';
// import lkRolesBody from './lk/roles-body.js';
// import lkFestivalsBody from './lk-catalogs/festivals-body.js';
// import lkCinemasBody from './lk-catalogs/cinemas-body.js';
import lkJury from './lk/jury.js';
import lkPlaces from './lk/places.js';
// import lkStudiosBody from './lk-catalogs/studios-body.js';
// import festhalls from './fest/halls.js';
import festProgramms from './lk/programms.js';
import festFilmApplicationsForConsider from './lk/filmApplicationsForConsider.js';
import festPosters from './fest/posters.js';
import festAds from './fest/Ads.js';
// import festFilms from './film_fests/film_fest.js';
import festSchedule from './lk/schedule.js';
import festUsers from './fest/users.js';
// import festUsersProfi from './fest/users-profi.js';
import festVoteList from './fest/vote-list.js';
 // import logButton from './buttons/log.js';
import profileButton from './buttons/online__profile.js';
import filmExport from './lk/filmExport.js';
import filmExportPDF from './lk/filmExportPDF.js';
import streams from './lk/streams.js';
import events from './lk/events.js';

import mailing from './lk/mailing.js';
import festSettings from './fest/festSettings.js';

import telegramBot from './tabFestApp/telegramBot.js';
import telegramBotMailing from './tabFestApp/mailing.js';


import chats from './lk/chats/chats.js';
import b2bDocs from './lk/b2b/docs.js';


// import xhr from './tools/xhr.js';
//  Отправка без валидации
//  import cardsResourcesButton from './buttons/catalog__cards--add-resource.js';


// import EasyYandexS3 from 'easy-yandex-s3';


const exit = document.querySelector('#profile-exit');
const app = document.querySelector('#app');
const login = document.querySelector('#login');

// const userList = document.querySelector('#loginInputLogin');
// const btMenuOperations = document.querySelector('list-operations-list');

const showLoginHideApp = () => {
  login.classList.remove('d-none');
  app.classList.add('d-none');
  // console.log('showLoginHideApp');
};

const showAppHideLogin = () => {
  login.classList.add('d-none');
  app.classList.remove('d-none');
  // console.log('showAppHideLogin');
};

//  чистим меню и вкладки
const initMarkup = () => {
  document.querySelectorAll('.nav-link').forEach((item) => item.classList.remove('active'));
  document.querySelectorAll('.nav-item.dropdown').forEach((item) => item.classList.remove('show'));
  document.querySelectorAll('.tab-pane').forEach((item) => item.classList.add('fade'));
  document.querySelectorAll('.dropdown-item').forEach((item) => item.classList.remove('active'));

  /* if ((auth.data.operatorId === '5') || (auth.data.operatorId === '1')) {
    // hid('CASSA-counter-list',3);
  } else {
    hid('calendar-clear-old-data');
    hid('calendar-generate-new-data');
    hid('CASSA-counter-list');
  }*/
};
/*
function hid(element) {
  let drop = document.getElementById(element);
  drop.style.visibility = 'hidden';
}*/
const hashObserver = () => {
  let hash = window.location.hash;
  if (hash) {
    // console.log(hash);
    document.querySelector(`${hash}-list`).dispatchEvent(new Event('click'));
    document.querySelector(`${hash}-list`).classList.add('active');
    document.querySelector(`${hash}`).classList.add('active');
    document.querySelector(`${hash}`).classList.remove('fade');
  }
};



const mainMenuButtons = [
  // mainViewContent,
  // searchViewFestContent,
  lkPlaces,
  // lkCinemasBody,
  lkJury,
  universalListOfData,
  festProgramms,
  festFilmApplicationsForConsider,
  festPosters,
  festAds,
  // festFilms,
  // festUsersProfi,
  festSchedule,
  festVoteList,
  streams,
  festUsers,
  events,
  mailing,
  festSettings,
  filmExport,
  telegramBot,
  telegramBotMailing,
  chats,
  b2bDocs
  // lkTechnologiesBody

];

//  ========== ОБНОВЛЕНИЕ/ОТКРЫТИЕ СТРАНИЦЫ ==========
const start = () => {
  auth.goodsViewMode = 'string';
  // console.log(auth);
  if (auth.isSetFlag && auth.data.operatorId) {
    showAppHideLogin();
    initMarkup();
    hashObserver();
    mainMenuButtons.forEach((item) => item.start());
    permissions.read();

  } else {
    showLoginHideApp();
    mainWindow.init();
    // getAllUsers();

  }
};

//  ========== ВЫХОД ==========
const wideScreenBtn = document.querySelector('#widescreen-mode-btn');

const onWideScreenBtnClick = () => {
  const screenWidth = document.body.clientWidth;
  if (!wideScreenBtn.classList.contains('icon-btn__widescreen--active') && screenWidth > 1300) {
    wideScreenBtn.classList.add('icon-btn__widescreen--active');
    app.style.maxWidth = (screenWidth - 50) + 'px';
  } else if (wideScreenBtn.classList.contains('icon-btn__widescreen--active') && screenWidth > 1300) {
    app.style.maxWidth = '1140px';
    console.log(document.body.clientWidth);
    wideScreenBtn.classList.remove('icon-btn__widescreen--active');
  }
  console.log((wideScreenBtn.classList.contains('icon-btn__widescreen--active') && screenWidth > 1300));
};

wideScreenBtn.addEventListener('click', onWideScreenBtnClick);
//  ==========  ==========

//  ========== ВЫХОД ==========
const stop = () => {
/*  xhr.request = {
    metod: 'POST',
    url: `crm/user/${auth.data.operatorId}/logout/`,
    data: `token=${auth.data.token}`,
    callbackSuccess: onSuccessReuestAction,
  };
*/
  showLoginHideApp();
  auth.clean();
  mainMenuButtons.forEach((item) => item.stop());
  window.location.hash = '';
  document.dispatchEvent(new Event('logoutSuccess'));
};




// POPUP
const mypopup = document.getElementById("mypopup");

function addPopupListener() {
  let allPopUpListener = document.querySelectorAll('button');

  allPopUpListener.forEach((buttonItem) => {
    if (buttonItem.attributes.popupAlert) {
      buttonItem.addEventListener("mouseover", showPopup);
      buttonItem.addEventListener("mouseout", hidePopup);
    }
  });

}

function showPopup(evt) {

  mypopup.querySelector('b').innerHTML = '';
  mypopup.querySelector('div').innerHTML = '';

  if (evt.target.attributes.popupAlert)
    mypopup.querySelector('b').innerHTML = evt.target.attributes.popupAlert.nodeValue;

  if (evt.target.attributes.popupMsg) {
    mypopup.querySelector('div').style.display = 'flex';
    mypopup.querySelector('div').innerHTML = evt.target.attributes.popupMsg.nodeValue;
  } else
    mypopup.querySelector('div').style.display = 'none';
  


  let iconPos = evt.target.getBoundingClientRect();
  mypopup.style.left = (iconPos.right - 80) + "px";
  mypopup.style.top = (window.scrollY + iconPos.top + 60) + "px";
  mypopup.style.display = "block";
}

function hidePopup(evt) {
  mypopup.style.display = "none";
}
/*

const onSuccessReuestActionUserList = (sheduleData) => {
 // document.querySelector(`#${loaderSpinnerId}`).remove();   style = "width:100%"
  if (sheduleData.status === 200) {
    console.log('200');
    let i = 0;
    for (i = userList.options.length - 1; i >= 0; i--) {
      userList.remove(i);
    }

    let countUserInList = sheduleData.data.length;

    for (i = 0; i < countUserInList; i++) {
      let opt = document.createElement('option');
      opt.value = sheduleData.data[i].email;
      opt.innerHTML = sheduleData.data[i].nickname;
      userList.appendChild(opt);
    }
  }
};
*/
/*
const onSuccessReuestAction = (sheduleData) => {
 // document.querySelector(`#${loaderSpinnerId}`).remove();   style = "width:100%"
  if (sheduleData.status === 200) {
    console.log('200');
  }
};

*/

//  ========== Добавление в список обновлений! ==========
// loadListOfFestivals();


function displayWhatNews() {

  let arrNews = [{"time":"08.02.2025",'title':"Исправлена сортировка заявок при включении фильтра входящих сообщений."},
                {"time":"07.02.2025",'title':"Добавлена поддержка прошлогодних заявок для 'Открытой премьеры'."},
                {"time":"16.05.2024",'title':" Добавлена новая функция: Теперь если заявитель получил уведомление 'O новом сообщении от организатора' и ответил прямо из почты, то платформа автоматически подзагрузит его ответ в нужный чат."},
                {"time":"18.02.2024",'title':"Добавлен новый пункт меню для работы с договорами сторонних площадок."},
                {"time":"17.12.2023",'title':"Исправлена ошибка поиска работ при числовых названиях."},
                {"time":"10.12.2023","title":"Добавлена поддержка проверки фотографий в резервной копии."},
                {"time":"06.09.2023","title":'Улучшена механика работы с блоком "программы" при добавлении его в расписание.'},
                {"time":"02.09.2023","title":" Добавлена поддержка загрузки нескольких фотографии при локальном переносе фильма."},
                {"time":"02.03.2023","title":'Поправлена работа блока "Жюри" и "программы кинофестиваля".'},
                {"time":"25.02.2023","title":'Добавлен новый тип работ: "Медиатека".'},
                {"time":"23.02.2023","title":'Добавлена новая функция - "Рассылка сообщений пользователям telegram-bot`a'},
                {"time":"9.02.2023","title":'Добавлена новая вкладка в меню - "FestApp"<br>Добавлено новое окно - "Telegram bot"'}];
                // {"time":"","title":""},
                // {"time":"","title":""},
                // {"time":"","title":""},
                // {"time":"","title":""}


                  

  let lastIndex = 63 + arrNews.length;

  let arrNewsBody = '';
  arrNews.forEach((element) => {
    arrNewsBody += `
          <div class="row m-0 p-1 cloud">
              <div class="column numberNPeriod">
                <b class="w-100 txt-al-center"> #${lastIndex}</b>
                <small>${element.time}</small>
              </div>
              <span class="ml-3 " style="width: calc(100% - 100px);">${element.title}</span>
            </div>
    `;
    --lastIndex;

  })

  document.querySelector('#newsFuncsBody').innerHTML = arrNewsBody;


}
//



initMarkup();
hashObserver();
start();
addPopupListener();
displayWhatNews();
document.addEventListener('loginSuccess', start);
document.addEventListener('authError', stop);
//  ========== ЗАВЕРШЕНИЕ РАБОТЫ ==========
exit.addEventListener('click', stop);
